"use strict";

module.exports = function (obj, defaults) {
  return Object.keys(defaults).concat(Object.keys(obj)).reduce(function (target, prop) {
    target[prop] = typeof obj[prop] === 'undefined' ? defaults[prop] : obj[prop];
    return target;
  }, {});
};


// WEBPACK FOOTER //
// ../node_modules/@sanity/client/lib/util/defaults.js